export const GET_APPLICATION_REQUEST = 'GET_APPLICATION_REQUEST';
export const GET_APPLICATION_SUCCESS = 'GET_APPLICATION_SUCCESS';
export const GET_APPLICATION_FAILURE = 'GET_APPLICATION_FAILURE';
